import { LicenseAction } from '../../actions/resources/License';
import * as Constants from '../../constants/resources';
import initialState from '../../InitialState';
import { State } from '../../types/resources/State';
import { ApiStatus } from '../../types/api-status';

const license = (state: State = initialState, action: LicenseAction): State => {
  switch (action.type) {
    case Constants.LICENSES:
      return {
        ...state,
        license: {
          ...state.license,
          licensesLoading: true,
          syncUsageRequestId: '',
          sysUsageStatus: ApiStatus.NotExecuted
        }
      };
    case Constants.LICENSES_SUCCESS:
      return {
        ...state,
        license: {
          ...state.license,
          licenses: action.payload.licenses,
          syncUsageRequestId: '',
          licensesLoading: false
        }
      };
    case Constants.LICENSES_FAILED:
      return {
        ...state,
        license: {
          ...state.license,
          licenses: [],
          sysUsageStatus: ApiStatus.Error,
          licensesLoading: false
        }
      };
    case Constants.LICENSE_SYNC_USAGE:
      return {
        ...state,
        license: {
          ...state.license,
          syncUsageRequestId: '',
          sysUsageStatus: ApiStatus.InProgress
        }
      };
    case Constants.LICENSE_SYNC_USAGE_SUCCESS:
      return {
        ...state,
        license: {
          ...state.license,
          syncUsageRequestId: action.payload.requestID,
          sysUsageStatus: ApiStatus.Completed
        }
      };
    case Constants.LICENSE_SYNC_USAGE_FAILED:
      return {
        ...state,
        license: {
          ...state.license,
          syncUsageRequestId: '',
          sysUsageStatus: ApiStatus.Error
        }
      };
    case Constants.LICENSE_DETAIL:
      return {
        ...state,
        license: {
          ...state.license,
          selectedLicense: {
            ...state.license.selectedLicense,
            selectedLicenseLoading: true
          }
        }
      };
    case Constants.LICENSE_DETAIL_SUCCESS:
      return {
        ...state,
        license: {
          ...state.license,
          selectedLicense: {
            ...state.license.selectedLicense,
            detail: action.payload.licenseDetail,
            selectedLicenseLoading: false
          }
        }
      };
    case Constants.LICENSE_DETAIL_FAILED:
      return {
        ...state,
        license: {
          ...state.license,
          selectedLicense: {
            ...state.license.selectedLicense,
            selectedLicenseLoading: false
          }
        }
      };
    case Constants.LICENSE_REFERENCES:
      return {
        ...state,
        license: {
          ...state.license,
          licensesLoading: true
        }
      };
    case Constants.LICENSE_REFERENCES_SUCCESS:
      return {
        ...state,
        license: {
          ...state.license,
          selectedLicense: {
            ...state.license.selectedLicense,
            references: action.payload.licenseReferences,
            selectedLicenseLoading: false
          }
        }
      };
    case Constants.LICENSE_REFERENCES_FAILED:
      return {
        ...state,
        license: {
          ...state.license,
          selectedLicense: {
            ...state.license.selectedLicense,
            references: {
              environments: [],
              containers:[]
            },
            selectedLicenseLoading: false
          }
        }
      };
    default:
      return state;
  }
};

export default license;
